module.exports = __webpack_public_path__ + "static/media/people-at-concert.9d568b02.png";